import React from 'react';

export interface OnOffStyle05Props {
  isOn: boolean;
  disabled?: boolean;
  loading?: boolean;
  onToggle: () => void;
  label?: string;
}

/**
 * OnOff Style 05 - Text Button
 * Simple text button on the right side (電源: OFF/ON)
 * Shows opposite state on hover to indicate action
 */
export const Style05_TextButton: React.FC<OnOffStyle05Props> = ({
  isOn,
  disabled = false,
  loading = false,
  onToggle,
  label = '電源'
}) => {
  return (
    <div className="flex items-center justify-between">
      <span className="text-sm text-slate-300">{label}</span>
      <button
        onClick={onToggle}
        disabled={disabled || loading}
        className={`group px-4 py-1.5 rounded-lg font-medium text-sm transition-all ${
          isOn 
            ? 'bg-blue-500 text-white hover:bg-red-500' 
            : 'bg-slate-700/50 text-slate-400 hover:bg-green-500 hover:text-white'
        } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        {loading ? '...' : (
          <>
            <span className="group-hover:hidden">{isOn ? '開' : '關'}</span>
            <span className="hidden group-hover:inline">{isOn ? '關' : '開'}</span>
          </>
        )}
      </button>
    </div>
  );
};

export default Style05_TextButton;
